import { __assign, __extends, __spreadArrays } from "tslib";
import * as React from 'react';
import { SortableList } from '../../../primitives';
export var keyCodes = {
    escape: 27,
    backspace: 8,
    space: 32,
    k: 75,
    enter: 13,
    upArrow: 38,
    downArrow: 40
};
var keyHandler = function (e, listRef) {
    switch (e.which) {
        case keyCodes.enter:
            listRef.selectItem(e);
            e.preventDefault();
            return true;
        case keyCodes.upArrow:
            listRef.moveUp();
            e.preventDefault();
            return true;
        case keyCodes.downArrow:
            listRef.moveDown();
            e.preventDefault();
            return true;
        default:
            return false;
    }
};
// tslint:disable-next-line:max-line-length
var createHandledList = function (items, ItemRenderer, onSelect, selectedtItem, _, onSortEnd) {
    var listReference;
    var listElement;
    var listChildNodes;
    var selectedIndex = -1;
    var limit = items.length;
    var updateSelectedIndex = function () {
        selectedIndex = listReference.state.selectedIndex;
    };
    var updateListPosition = function () {
        updateSelectedIndex();
        listElement.scrollTop = listChildNodes[selectedIndex].scrollIntoView();
    };
    var throwIfNoList = function () {
        if (!listReference || !listElement) {
            throw new Error('List component was not mounted but key handler was used!');
        }
        else {
            updateSelectedIndex();
        }
    };
    var allItemsDisabled = function () { return items.findIndex(function (item) { return !item.disabled; }) === -1; };
    var findNextNotDisabledItem = function (startIdx, reverse) {
        var itemsArr = reverse ? __spreadArrays(items).reverse() : items;
        var itemIdx = reverse ? items.length - startIdx - 1 : startIdx;
        var mabyeNextIdx = itemsArr.findIndex(function (item, idx) { return idx >= itemIdx && !item.disabled; });
        var newIdx = reverse ? items.length - mabyeNextIdx - 1 : mabyeNextIdx;
        return (newIdx !== -1) ? newIdx : itemsArr.findIndex(function (item) { return !item.disabled; });
    };
    var controls = {
        selectItem: function (e) {
            throwIfNoList();
            var selectedItem = items[selectedIndex];
            if (selectedItem && !selectedItem.disabled) {
                onSelect(selectedItem, e);
            }
        },
        moveDown: function () {
            throwIfNoList();
            if (!allItemsDisabled()) {
                var indexToSelect = selectedIndex > limit - 1 ? 0 : selectedIndex + 1;
                var newIdx_1 = findNextNotDisabledItem(indexToSelect);
                listReference.setState({ selectedIndex: newIdx_1 }, function () {
                    updateSelectedIndex();
                    if (newIdx_1 > -1 && newIdx_1 < limit && limit > 4) {
                        listElement.scrollTop = listChildNodes[newIdx_1].scrollIntoView();
                    }
                });
            }
        },
        moveUp: function () {
            throwIfNoList();
            if (!allItemsDisabled()) {
                var indexToSelect = selectedIndex <= 0 ? limit - 1 : selectedIndex - 1;
                var newIdx_2 = findNextNotDisabledItem(indexToSelect, true);
                listReference.setState({ selectedIndex: newIdx_2 }, function () {
                    updateSelectedIndex();
                    if (newIdx_2 < limit && newIdx_2 > -1 && limit > 4) {
                        listElement.scrollTop = listChildNodes[newIdx_2].scrollIntoView();
                    }
                });
            }
        }
    };
    var List = /** @class */ (function (_super) {
        __extends(List, _super);
        function List() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.state = {
                selectedIndex: -1,
                updateComponent: false
            };
            _this.onListRef = function (ref) {
                listElement = ref;
                listChildNodes = ref && ref.children;
            };
            return _this;
        }
        List.prototype.componentDidMount = function () {
            listReference = this;
            if (selectedtItem) {
                items.forEach(function (arg, i) {
                    if (arg.id === selectedtItem.id) {
                        listReference.setState({ selectedIndex: i, updateComponent: true });
                    }
                });
            }
        };
        List.prototype.componentDidUpdate = function () {
            if (selectedtItem && this.state.updateComponent) {
                this.setState({ updateComponent: false });
                updateListPosition();
            }
        };
        List.prototype.render = function () {
            var _this = this;
            var itemProps = function (item, index) {
                var selected = index === _this.state.selectedIndex;
                return { item: item, index: index, items: items, selected: selected, disabled: item.disabled };
            };
            var listItems = items.map(function (item, i) { return React.createElement(ItemRenderer, __assign({ key: i }, itemProps(item, i))); });
            var maybeSortableList = onSortEnd ? (React.createElement(SortableList, { useDragHandle: true, items: listItems, onSortEnd: onSortEnd }, listItems)) : (listItems);
            return (React.createElement("ul", { className: 'key-handled-list-container', ref: this.onListRef }, maybeSortableList));
        };
        return List;
    }(React.Component));
    return {
        component: List,
        keyHandler: function (e) {
            return keyHandler(e, controls);
        }
    };
};
export function createKeyHandledList(items, 
// React.Component<T, any> | React.StatelessComponent<T> | Element,
itemRenderer, onSelect, selectedtItem, onSortEnd) {
    return createHandledList(items, itemRenderer, onSelect, selectedtItem, undefined, onSortEnd);
}
//# sourceMappingURL=key-handled-list.comp.js.map